import { render } from "./CoinFlip.vue?vue&type=template&id=5c115814&ts=true"
import script from "./CoinFlip.vue?vue&type=script&lang=ts"
export * from "./CoinFlip.vue?vue&type=script&lang=ts"

import "./CoinFlip.vue?vue&type=style&index=0&id=5c115814&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__